import { StyleSheet } from 'react-native';

import { isTabletOrWeb } from 'utils/responsiveness';

const styles = StyleSheet.create({
    iconContainer: {
        marginRight: isTabletOrWeb ? 12 : 8,
        height: 20,
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default styles;
